(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cstm_all_collection_list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const sectionEl = document.querySelector('.cstm_all_collection');
  const perPage = parseInt(sectionEl.getAttribute('data-per-page'), 10) || 12;

  const grid = document.getElementById("ajax-collection-grid");
  const paginationContainer = document.getElementById("collection-pagination");

  const allCollections = Array.from(grid.children);
  let currentPage = 1;

  function renderPagination(totalItems) {
    const totalPages = Math.ceil(totalItems / perPage);
    paginationContainer.innerHTML = "";
    if (totalPages <= 1) return;

    // const createBtn = (text, disabled, page, type) => {
    //   const btn = document.createElement("button");
    //   btn.textContent = text;
    //   if (type === "arrow") btn.classList.add("icon_coll_arow");
    //   if (type === "number") btn.classList.add("icon_coll_number");
    //   if (disabled) btn.disabled = true;
    //   else btn.addEventListener("click", () => {
    //     currentPage = page;
    //     renderCollections();
    //   });
    //   return btn;
    // };

    const createBtn = (text, disabled, page, type) => {
      const btn = document.createElement("button");
      btn.textContent = text;

      if (type === "arrow") btn.classList.add("icon_coll_arow");
      if (type === "number") btn.classList.add("icon_coll_number");

      if (disabled) {
        btn.disabled = true;
      } else {
        btn.addEventListener("click", () => {
          currentPage = page;
          renderCollections();
          scrollToCollectionsTop(); 
        });
      }
      return btn;
    };

    function scrollToCollectionsTop() {
      const target = document.getElementById("cstm_list_collect");
      if (!target) return;

      const headerHeight = document.querySelector("header")?.offsetHeight || 80;
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    }


    // Previous
    paginationContainer.appendChild(createBtn("<", currentPage === 1, currentPage - 1, "arrow"));

    // Page numbers
    for (let i = 1; i <= totalPages; i++) {
      const btn = createBtn(i, false, i, "number");
      if (i === currentPage) btn.classList.add("active");
      paginationContainer.appendChild(btn);
    }

    // Next
    paginationContainer.appendChild(createBtn(">", currentPage === totalPages, currentPage + 1, "arrow"));
  }

  function renderCollections() {
    const start = (currentPage - 1) * perPage;
    const end = start + perPage;
    grid.innerHTML = "";
    allCollections.slice(start, end).forEach(col => grid.appendChild(col.cloneNode(true)));
    renderPagination(allCollections.length);
  }

  renderCollections();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm_blog_page_section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const sectionEl = document.querySelector('.cstm_blog_page');
  const perPage = parseInt(sectionEl.getAttribute('data-per-page'), 10) || 6;

  const grid = document.getElementById("ajax-blog-grid");
  const paginationContainer = document.getElementById("blog-pagination");

  const allPosts = Array.from(grid.children);
  let currentPage = 1;

  function renderPagination(totalItems) {
    const totalPages = Math.ceil(totalItems / perPage);
    paginationContainer.innerHTML = "";
    if (totalPages <= 1) return;

    // const createBtn = (text, disabled, page, type) => {
    //   const btn = document.createElement("button");
    //   btn.textContent = text;
    //   if (type === "arrow") btn.classList.add("icon_coll_arow");
    //   if (type === "number") btn.classList.add("icon_coll_number");
    //   if (disabled) btn.disabled = true;
    //   else btn.addEventListener("click", () => {
    //     currentPage = page;
    //     renderPosts();
    //   });
    //   return btn;
    // };
    const createBtn = (text, disabled, page, type) => {
      const btn = document.createElement("button");
      btn.textContent = text;

      if (type === "arrow") btn.classList.add("icon_coll_arow");
      if (type === "number") btn.classList.add("icon_coll_number");

      if (disabled) {
        btn.disabled = true;
      } else {
        btn.addEventListener("click", () => {
          currentPage = page;
          renderPosts();
          scrollToBlogTop(); 
        });
      }
      return btn;
    };

    paginationContainer.appendChild(createBtn("<", currentPage === 1, currentPage - 1, "arrow"));

    for (let i = 1; i <= totalPages; i++) {
      const btn = createBtn(i, false, i, "number");
      if (i === currentPage) btn.classList.add("active");
      paginationContainer.appendChild(btn);
    }

    paginationContainer.appendChild(createBtn(">", currentPage === totalPages, currentPage + 1, "arrow"));
  }

  function renderPosts() {
    const start = (currentPage - 1) * perPage;
    const end = start + perPage;
    grid.innerHTML = "";
    allPosts.slice(start, end).forEach(post => grid.appendChild(post.cloneNode(true)));
    renderPagination(allPosts.length);
  }

  function scrollToBlogTop() {
    const target = document.getElementById("all_blog_news");
    if (!target) return;

    const headerHeight = document.querySelector("header")?.offsetHeight || 80;
    const top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight;

    window.scrollTo({
      top: top,
      behavior: "smooth"
    });
  }


  renderPosts();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm_collection_single"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.getElementById("ajax-product-grid");
  const filterForm = document.getElementById("filter-form");
  const sortDropdown = document.getElementById("sort-by-dropdown");
  const perPage = document.getElementById("per-page-dropdown");
  const paginationContainer = document.getElementById("pagination");
  const filterBtn = document.querySelector(".cstm_filter");
  const sidebar = document.querySelector(".left_filter_bar");

  const minInput = filterForm.querySelector('input[name="price_min"]');
  const maxInput = filterForm.querySelector('input[name="price_max"]');
  const rMin = filterForm.querySelector(".range-min");
  const rMax = filterForm.querySelector(".range-max");
  const rangeValueMin = filterForm.querySelector(".range-value-min");
  const rangeValueMax = filterForm.querySelector(".range-value-max");
  const resetPriceBtn = filterForm.querySelector("#reset-price-range");

  let currentPage = 1;
  let allItems = []; // store all products for filtering & pagination

  function getCurrencySymbol() {
    const firstPriceEl = productGrid.querySelector(".price_col:not(.out-of-stock-label)");
    if (!firstPriceEl) return "£";
    const match = firstPriceEl.textContent.match(/^\D+/);
    return match ? match[0].trim() : "£";
  }
  const currencySymbol = getCurrencySymbol();

  function initAllItems() {
    allItems = Array.from(productGrid.children).map(node => {
      const el = node.cloneNode(true);
      const priceEl = el.querySelector(".price_col");
      const isOut = el.querySelector(".out-of-stock-label") !== null;
      // Quote-only tiles have no price at all. They must never be filtered out by the
      // price slider, so flag them and skip the price test entirely.
      const isQuote = el.querySelector(".price_col_poa") !== null;
      const priceNum = priceEl ? parseFloat(priceEl.textContent.replace(/[^\d.]/g, "")) || 0 : 0;
      return { el, outOfStock: isOut, isQuote, priceNum };
    });
  }

  function getProductPrices() {
    const prices = allItems.filter(i => !i.isQuote).map(i => i.priceNum).filter(p => !isNaN(p));
    if (!prices.length) return [0, 1000];
    return [Math.min(...prices), Math.max(...prices)];
  }

  function initSliderUI() {
    const [minP, maxP] = getProductPrices();
    minInput.value = minP;
    maxInput.value = maxP;
    rMin.value = minP;
    rMax.value = maxP;
    rMin.min = minP;
    rMin.max = maxP;
    rMax.min = minP;
    rMax.max = maxP;
    rangeValueMin.textContent = currencySymbol + minP.toLocaleString();
    rangeValueMax.textContent = currencySymbol + maxP.toLocaleString();
  }

  function syncRangeDisplay() {
    let minV = parseFloat(minInput.value);
    let maxV = parseFloat(maxInput.value);
    if (minV > maxV) minV = maxV;
    if (maxV < minV) maxV = minV;
    rMin.value = minV;
    rMax.value = maxV;
    rangeValueMin.textContent = currencySymbol + minV.toLocaleString();
    rangeValueMax.textContent = currencySymbol + maxV.toLocaleString();
  }

  initAllItems();
  initSliderUI();

  rMin.addEventListener("input", () => {
    minInput.value = rMin.value;
    rangeValueMin.textContent = currencySymbol + rMin.value;
  });
  rMax.addEventListener("input", () => {
    maxInput.value = rMax.value;
    rangeValueMax.textContent = currencySymbol + rMax.value;
  });
  minInput.addEventListener("change", syncRangeDisplay);
  maxInput.addEventListener("change", syncRangeDisplay);

  resetPriceBtn?.addEventListener("click", () => {
    initSliderUI();
    currentPage = 1;
    renderProducts();
  });

  document.querySelectorAll('.collection__filter-group [data-action="toggle"]').forEach(btn => {
    btn.addEventListener('click', () => {
      const options = btn.nextElementSibling;
      if (!options) return;
      options.classList.toggle('open');
      options.style.maxHeight = options.classList.contains('open') ? options.scrollHeight + "px" : null;
    });
  });

  if (filterBtn && sidebar) {
    filterBtn.addEventListener("click", () => sidebar.classList.toggle("open"));
    sidebar.addEventListener("click", e => {
      if (e.target === sidebar) sidebar.classList.remove("open");
    });
  }

  document.querySelectorAll(".view_switch_btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const view = btn.dataset.view;
      if (view === "grid") {
        productGrid.classList.add("cstm_col_grid");
        productGrid.classList.remove("single_prodcut_info");
      } else {
        productGrid.classList.remove("cstm_col_grid");
        productGrid.classList.add("single_prodcut_info");
      }
    });
  });

  function onFilterChange() {
    if (window._filterDebounce) clearTimeout(window._filterDebounce);
    window._filterDebounce = setTimeout(() => {
      currentPage = 1;
      renderProducts();
    }, 200);
  }

  minInput.addEventListener("change", onFilterChange);
  maxInput.addEventListener("change", onFilterChange);
  rMin.addEventListener("change", onFilterChange);
  rMax.addEventListener("change", onFilterChange);
  sortDropdown?.addEventListener("change", onFilterChange);
  perPage?.addEventListener("change", onFilterChange);
  filterForm.querySelectorAll('input[name="availability"]').forEach(cb => cb.addEventListener("change", onFilterChange));

  function renderPagination(totalItems, perPageVal) {
    const totalPages = Math.ceil(totalItems / parseInt(perPageVal));
    paginationContainer.innerHTML = "";
    if (totalPages <= 1) return;

    const createBtn = (text, disabled, page, type) => {
      const btn = document.createElement("button");
      btn.textContent = text;

      if (type === "arrow") btn.classList.add("icon_coll_arow");
      if (type === "number") btn.classList.add("icon_coll_number");

      if (disabled) {
        btn.disabled = true;
      } else {
        btn.addEventListener("click", () => {
          currentPage = page;
          renderProducts();
          scrollToCollectionTop();
        });
      }
      return btn;
    };

    paginationContainer.appendChild(createBtn("<", currentPage === 1, currentPage - 1, "arrow"));
    for (let i = 1; i <= totalPages; i++) {
      const btn = createBtn(i, false, i, "number");
      if (i === currentPage) btn.classList.add("active");
      paginationContainer.appendChild(btn);
    }
    paginationContainer.appendChild(createBtn(">", currentPage === totalPages, currentPage + 1, "arrow"));
  }


  function scrollToCollectionTop() {
    // PGE round 1 - Jonathan: clicking a pagination number was scrolling
    // all the way back up to #single_coll_page, which sits above the long
    // collection description/SEO copy at the very top of the page. He wants
    // it to land at the top of the product cards instead, so shoppers
    // don't have to re-read all that text every time they turn a page.
    // Retargeted at the product grid itself (#ajax-product-grid), with a
    // small upward offset so the "Display / Sort / View" toolbar directly
    // above the grid stays in view too, and a bit of headroom in case a
    // sticky header overlaps the very top of the viewport.
    const target = document.getElementById("ajax-product-grid");
    if (!target) return;

    const headerOffset = 140;
    const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: top,
      behavior: "smooth"
    });
  }


  function renderProducts() {
    let items = [...allItems];

    // -----------------------------
    // Apply filters
    // -----------------------------
    const selectedAvailability = Array.from(filterForm.querySelectorAll('input[name="availability"]:checked')).map(c => c.value);
    const minV = parseFloat(minInput.value);
    const maxV = parseFloat(maxInput.value);

    items = items.filter(item => {
      // Availability filter
      if (selectedAvailability.length) {
        const isInStock = !item.outOfStock;
        if (selectedAvailability.includes("in-stock") && !isInStock) return false;
        if (selectedAvailability.includes("out-of-stock") && isInStock) return false;
      }
      // Price filter - quote-only products have no price, so never hide them on price
      if (item.isQuote) return true;
      if (item.priceNum < minV || item.priceNum > maxV) return false;
      return true;
    });

    // -----------------------------
    // Sorting
    // -----------------------------
    const sortVal = sortDropdown?.value;
    if (sortVal === "title-ascending") items.sort((a, b) => a.el.querySelector(".col_title").textContent.localeCompare(b.el.querySelector(".col_title").textContent));
    else if (sortVal === "title-descending") items.sort((a, b) => b.el.querySelector(".col_title").textContent.localeCompare(a.el.querySelector(".col_title").textContent));
    // Price sorts push quote-only items to the end rather than treating them as free
    else if (sortVal === "price-ascending") items.sort((a, b) => (a.isQuote ? 1 : 0) - (b.isQuote ? 1 : 0) || a.priceNum - b.priceNum);
    else if (sortVal === "price-descending") items.sort((a, b) => (a.isQuote ? 1 : 0) - (b.isQuote ? 1 : 0) || b.priceNum - a.priceNum);

    // -----------------------------
    // Update counters
    // -----------------------------
    document.getElementById("count-in-stock").textContent = allItems.filter(i => !i.outOfStock).length;
    document.getElementById("count-out-of-stock").textContent = allItems.filter(i => i.outOfStock).length;

    // -----------------------------
    // Paginate items
    // -----------------------------
    const perPageVal = parseInt(perPage?.value || 15);
    const start = (currentPage - 1) * perPageVal;
    const end = start + perPageVal;
    const pagedItems = items.slice(start, end);

    // Render
    productGrid.innerHTML = "";
    if (pagedItems.length) {
      pagedItems.forEach(i => productGrid.appendChild(i.el));
    } else {
      productGrid.innerHTML = "<p>No products found.</p>";
    }

    renderPagination(items.length, perPageVal);
  }

  // Initial render
  renderProducts();
});

  } catch(e) { console.error(e); }
})();
})();
